var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeafoodFish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7331 4.74011C11.5025 4.76145 7.33315 6.89878 5.91715 9.80678C5.75272 10.1715 5.70534 10.5782 5.7815 10.971C5.85767 11.3638 6.05364 11.7233 6.34248 12.0001L9.73315 15.3881",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1732 23.0228C24.6012 21.0054 32.1519 15.1121 30.8559 2.8561C30.8062 2.41918 30.6099 2.01199 30.2989 1.70105C29.988 1.39011 29.5808 1.19377 29.1439 1.1441C16.8879 -0.151895 10.9945 7.39877 8.9772 18.8268L1.54653 22.1334C1.37186 22.2214 1.22717 22.3591 1.13073 22.5292C1.0343 22.6994 0.990445 22.8942 1.00471 23.0893C1.01898 23.2843 1.09073 23.4708 1.2109 23.625C1.33106 23.7793 1.49426 23.8945 1.67987 23.9561L6.87987 25.1161L8.03987 30.3161C8.10145 30.5017 8.21665 30.6649 8.37094 30.7851C8.52522 30.9052 8.71165 30.977 8.90669 30.9913C9.10172 31.0055 9.29661 30.9617 9.46674 30.8652C9.63687 30.7688 9.7746 30.6241 9.86253 30.4494L13.1732 23.0228Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2598 16.2672C27.2385 20.4978 25.1012 24.6671 22.1932 26.0831C21.8284 26.2476 21.4217 26.295 21.029 26.2188C20.6362 26.1426 20.2767 25.9467 19.9998 25.6578L16.6158 22.2672",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97729 18.827L13.1733 23.023",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6C22.5989 6 22.6956 6.02932 22.7778 6.08427C22.86 6.13921 22.9241 6.2173 22.9619 6.30866C22.9998 6.40002 23.0097 6.50055 22.9904 6.59755C22.9711 6.69454 22.9235 6.78363 22.8536 6.85355C22.7836 6.92348 22.6945 6.9711 22.5975 6.99039C22.5006 7.00969 22.4 6.99978 22.3087 6.96194C22.2173 6.9241 22.1392 6.86001 22.0843 6.77779C22.0293 6.69556 22 6.59889 22 6.5C22 6.36739 22.0527 6.24022 22.1464 6.14645C22.2402 6.05268 22.3674 6 22.5 6Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeafoodFish);
export default __webpack_public_path__ + "static/media/SeafoodFish.ab2469d3b380e0dcda31b745116d4dcf.svg";
export { ForwardRef as ReactComponent };